module.exports = "pegasus/assets/themelp1/ebook/107.png";